import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { EmojiComponent, EmojiModule } from "@ctrl/ngx-emoji-mart/ngx-emoji";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Textarea } from "primeng/textarea";
import { Popover, PopoverModule } from "primeng/popover";
import { keyCodes } from "src/app/shared/models/key-codes.model";
import { Order, OrderNote } from "src/app/shared/models/order.model";
import { AuthService } from "src/app/shared/services/auth.service";
import { BroshService } from "src/app/shared/services/brosh.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { PickerComponent } from "@ctrl/ngx-emoji-mart";

@Component({
  selector: "order-notes",
  templateUrl: "./order-notes.component.html",
  styleUrls: ["./order-notes.component.scss"],
  imports: [
    CommonModule,
    TranslateModule,
    PopoverModule,
    EmojiModule,
    FormsModule,
    Textarea,
    PickerComponent,
  ],
  standalone: true,
})
export class OrderNotesComponent implements OnInit {
  @Input() order: Order;
  @Output() onCreateNote = new EventEmitter();

  newNote: OrderNote = new OrderNote();
  sending: boolean;
  keyCodes = keyCodes;
  displayActionsBtn: boolean;
  curNote: OrderNote;
  allowDelete: boolean;

  get newMsgPlaceholder(): string {
    return this.translateService.instant("translate.order.typeNote");
  }

  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    private sharedService: SharedService,
    private broshService: BroshService
  ) {
    this.allowDelete = this.authService.currentUser.authDetails.getBooleanValue(
      "ORDERS.DELETE_CHAT_NOTE_ALLOWED_SW"
    );
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.scrollToBottom();
  }

  sendNote() {
    this.sending = true;
    this.broshService.updOrderNote(this.order, this.newNote).subscribe(
      (data) => {
        this.sending = false;
        this.newNote = new OrderNote();
        this.onCreateNote.emit();
      },
      (error) => {
        this.sending = false;
        this.sharedService.alertError(error);
      }
    );
  }

  scrollToBottom = () => {
    var objDiv = document.getElementById("notes");
    if (objDiv) objDiv.scrollTop = objDiv.scrollHeight;
  };

  onKeyPress(e: any) {
    if (e.keyCode == keyCodes.enter) {
      this.sendNote();
    }
  }

  deleteNote(note: OrderNote) {
    let validationStr = this.translateService.instant(
      "translate.chat.deleteChatMsgValidation"
    );

    this.sharedService.emitPopupchReceivedEvent({
      title: "translate.chat.deleteChatMsgPrompt",
      icon: "exclamation-triangle",
      subTitle: validationStr,
      keep: false,
      approve: () => {
        this.broshService.updOrderNote(this.order, note, true).subscribe(
          (data) => {
            this.onCreateNote.emit();
          },
          (error) => {
            this.sending = false;
            this.sharedService.alertError(error);
          }
        );
      },
    });
  }

  onNoteClicked(note: OrderNote) {
    if (this.curNote == note) {
      this.curNote = null;
      this.displayActionsBtn = false;
    } else {
      this.curNote = note;
      this.displayActionsBtn = true;
    }
  }

  addEmoji($event, overlaypanel: Popover) {
    if (!this.newNote.text) {
      this.newNote.text = "";
    }
    this.newNote.text += " " + $event.emoji.native;
    overlaypanel.hide();
  }
}
